var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Customerbanonsale" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from1 },
        on: {
          Refresh: _vm.Refresh,
          search: _vm.search,
          handleOptionClick: _vm.handleOptionClick,
          selectlinkageclear: _vm.selectlinkageclear,
        },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      icon: "el-icon-upload2",
                      disabled: _vm.disabledExport,
                    },
                    on: { click: _vm.onHandleExport },
                  },
                  [_vm._v("导出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "supplier.title",
                  align: "center",
                  label: "供应商",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member.fullname",
                  align: "center",
                  label: "客户名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member.mobile",
                  align: "center",
                  label: "手机号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member.logistics.name",
                  align: "center",
                  label: "城市仓",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "restriction_type_text",
                  align: "center",
                  label: "禁售类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.restriction_type_name(scope.row)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  prop: "reason",
                  align: "center",
                  label: "申请原因",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "restriction_type_text",
                  align: "center",
                  label: "禁售内容",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "order_amt",
                  align: "center",
                  label: "客户售后数据",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.order_amt_name(scope.row)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  align: "center",
                  label: "申请时间\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "audit_time",
                  align: "center",
                  label: "审核时间\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "audit_user.username",
                  align: "center",
                  label: "审核人\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "audit_time",
                  align: "center",
                  label: "状态\n",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.audit_status_name(scope.row)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.audit_status == 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("通过")]
                            )
                          : _vm._e(),
                        scope.row.audit_status == 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("拒绝")]
                            )
                          : _vm._e(),
                        scope.row.audit_status == 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.Cancel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": 50,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title:
                  _vm.ruleForm.audit_status == 1
                    ? "通过拉黑申请"
                    : "拒绝拉黑申请",
                visible: _vm.centerDialogVisible,
                width: "500px",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.ruleForm.audit_status == 1 ? "" : "拒绝") +
                        "通过" +
                        _vm._s(_vm.itemobj.supplier.title) +
                        "供应商的拉黑申请； "
                    ),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: { model: _vm.ruleForm, "label-width": "100px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.ruleForm.audit_status == 1
                                ? "通过原因：(非必填)"
                                : "拒绝原因：(非必填)",
                            prop: "reason",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "请输入内容",
                                  maxlength: "200",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.audit_reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "audit_reason", $$v)
                                  },
                                  expression: "ruleForm.audit_reason",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.ruleFormqr },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }